import editSaga from './edit/edit.saga';
import listSaga from './list/list.saga';
import trackHistory from './track-history/track-history.saga';
import * as _ from 'lodash';

export default _.map([
    ...editSaga,
    ...listSaga,
    ...trackHistory,
]);
